<fnc-modal size="xlarge" #supportModal #upsellModal windowClasses="no-background max-50-vw">
  <modal-content *ngIf="!(loading$ | async)">
    <div class="support-modal-grid">
      <!-- Help center articles -->
      <div class="small-modal faq">
        <span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="inherit">
              <path d="M11 7.8h6.42a.92.92 0 0 0 0-1.84H11a.92.92 0 0 0 0 1.83Z" />
              <path
                d="M21.46 2.75 19.25.55a1.83 1.83 0 0 0-1.3-.55H7.34A1.83 1.83 0 0 0 5.5 1.83v6.68a.24.24 0 0 0 .22.23c.34 0 .92 0 1.37.07a.23.23 0 0 0 .24-.23V2.29a.46.46 0 0 1 .46-.46h9.97a.43.43 0 0 1 .33.14l1.94 1.94a.43.43 0 0 1 .14.32V16.5a.46.46 0 0 1-.46.46h-6.29a.23.23 0 0 0-.22.2 8.16 8.16 0 0 1-.37 1.33.22.22 0 0 0 .21.3h7.13A1.83 1.83 0 0 0 22 16.96V4.04a1.83 1.83 0 0 0-.54-1.29Z"
              />
              <path
                d="M16.04 11a.92.92 0 0 0-.92-.92h-3.66a.92.92 0 0 0-.65.3.14.14 0 0 0 0 .18 7.1 7.1 0 0 1 1.1 1.26.22.22 0 0 0 .18.1h3.04a.92.92 0 0 0 .91-.92ZM5.96 10.08a5.96 5.96 0 1 0 5.96 5.96 5.97 5.97 0 0 0-5.96-5.96Zm-.46 2.07a.92.92 0 1 1-.92.91.92.92 0 0 1 .92-.91Zm1.83 7.79H4.58a.69.69 0 0 1 0-1.38h.58a.11.11 0 0 0 .11-.1v-2.07a.12.12 0 0 0-.12-.12h-.57a.69.69 0 0 1 0-1.37h.92a1.15 1.15 0 0 1 1.15 1.14v2.4a.12.12 0 0 0 .11.12h.57a.69.69 0 0 1 0 1.38Z"
              />
            </svg>
          </span>
          <p>{{ 'MODALS.SUPPORT_MODAL.HELP_ARTICLES.DESCRIPTION' | translate }}</p>
        </span>
        <div buttons>
          <tlw-button white medium (click)="redirectToIntercomArticles()" *showForPlan="['Gratis', 'Basis', 'Plus']">{{
            'MODALS.SUPPORT_MODAL.HELP_ARTICLES.BUTTON_TEXT' | translate
          }}</tlw-button>
          <tlw-button purple medium (click)="redirectToIntercomArticles()" *showForPlan="['Compleet']">{{
            'MODALS.SUPPORT_MODAL.HELP_ARTICLES.BUTTON_TEXT' | translate
          }}</tlw-button>
        </div>
      </div>

      <!-- Live chat & Plan a Call for Plus -->
      <div class="small-modal chat">
        <span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="inherit">
              <path
                d="M9.4 11.05a2.3 2.3 0 0 1 2.29-2.29h6.64a.23.23 0 0 0 .23-.23V2.81a1.38 1.38 0 0 0-1.37-1.38H1.6A1.38 1.38 0 0 0 .23 2.8v9.17a1.38 1.38 0 0 0 1.37 1.38h1.38v3.2a.46.46 0 0 0 .46.46.43.43 0 0 0 .32-.13l3.57-3.53h1.84a.23.23 0 0 0 .23-.23Z"
              />
              <path
                d="M20.85 10.14H11.7a.92.92 0 0 0-.92.91v5.5a.92.92 0 0 0 .92.92h4.12l3.37 2.99a.46.46 0 0 0 .76-.35v-2.64h.91a.92.92 0 0 0 .92-.92v-5.5a.92.92 0 0 0-.92-.91Z"
              />
            </svg>
          </span>
          <p>{{ 'MODALS.SUPPORT_MODAL.LIVE_CHAT.DESCRIPTION' | translate }}</p>
        </span>
        <div buttons>
          <tlw-button white medium (click)="startSupport()" *showForPlan="['Gratis', 'Basis', 'Plus']">{{
            'MODALS.SUPPORT_MODAL.LIVE_CHAT.BUTTON_TEXT' | translate
          }}</tlw-button>
          <tlw-button white medium (click)="redirectToCalendly()" *showForPlan="['Plus']">
            {{ 'MODALS.SUPPORT_MODAL.PLAN_CALL.BUTTON_TEXT' | translate }}
          </tlw-button>

          <tlw-button purple medium (click)="startSupport()" *showForPlan="['Compleet']">{{
            'MODALS.SUPPORT_MODAL.LIVE_CHAT.BUTTON_TEXT' | translate
          }}</tlw-button>
        </div>
      </div>

      <!-- Plan a call - Only for Compleet -->
      <div class="small-modal plan-a-call" *showForPlan="['Compleet']">
        <span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="inherit">
              <path
                d="M6.88 9.63h-.92a.92.92 0 0 0 0 1.83h.91a.92.92 0 0 0 0-1.84ZM11.46 9.63h-.92a.92.92 0 0 0 0 1.83h.92a.92.92 0 0 0 0-1.84ZM16.04 9.63h-.92a.92.92 0 0 0 0 1.83h.92a.92.92 0 0 0 0-1.84ZM6.88 13.3h-.92a.92.92 0 0 0 0 1.82h.91a.92.92 0 0 0 0-1.83ZM11.46 13.3h-.92a.92.92 0 0 0 0 1.82h.92a.92.92 0 0 0 0-1.83ZM16.04 13.3h-.92a.92.92 0 0 0 0 1.82h.92a.92.92 0 0 0 0-1.83ZM6.88 16.96h-.92a.92.92 0 0 0 0 1.83h.91a.92.92 0 0 0 0-1.83ZM11.46 16.96h-.92a.92.92 0 0 0 0 1.83h.92a.92.92 0 0 0 0-1.83ZM16.04 16.96h-.92a.92.92 0 0 0 0 1.83h.92a.92.92 0 0 0 0-1.83Z"
              />
              <path
                d="M19.7 2.75H17.2a.23.23 0 0 1-.23-.23V.92a.92.92 0 0 0-1.84 0v4.35a.69.69 0 0 1-1.37 0V3.21a.46.46 0 0 0-.46-.46H7.56a.23.23 0 0 1-.23-.23V.92a.92.92 0 0 0-1.83 0v4.35a.69.69 0 0 1-1.38 0V3.21a.46.46 0 0 0-.45-.46H2.29A1.83 1.83 0 0 0 .46 4.58v15.59A1.83 1.83 0 0 0 2.29 22h17.42a1.83 1.83 0 0 0 1.83-1.83V4.58a1.83 1.83 0 0 0-1.83-1.83Zm0 16.96a.46.46 0 0 1-.45.46H2.75a.46.46 0 0 1-.46-.46v-11a.46.46 0 0 1 .46-.46h16.5a.46.46 0 0 1 .46.46Z"
              />
            </svg>
          </span>
          <p>{{ 'MODALS.SUPPORT_MODAL.PLAN_CALL.DESCRIPTION' | translate }}</p>
        </span>
        <div buttons>
          <tlw-button purple medium (click)="redirectToCalendly()">{{ 'MODALS.SUPPORT_MODAL.PLAN_CALL.BUTTON_TEXT' | translate }}</tlw-button>
        </div>
      </div>

      <!-- Direct call - Only for Compleet -->
      <div class="small-modal direct-call" *showForPlan="['Compleet']">
        <span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="inherit">
              <path
                d="m20.78 15.58-2.25-2.24a2.57 2.57 0 0 0-3.66 0l-.45.45a49.5 49.5 0 0 1-6.24-6.24l.46-.46a2.6 2.6 0 0 0 0-3.66L6.42 1.2a2.63 2.63 0 0 0-3.67 0L1.52 2.44a3.67 3.67 0 0 0-.46 4.58 49.72 49.72 0 0 0 13.9 13.9 3.67 3.67 0 0 0 4.6-.45l1.22-1.22a2.57 2.57 0 0 0 0-3.67Z"
              />
            </svg>
          </span>
          <p>{{ 'MODALS.SUPPORT_MODAL.DIRECT_CALL.DESCRIPTION' | translate }}</p>
        </span>
        <a number [attr.href]="'tel:' + inboundSupport.replace(' ', '')">{{ inboundSupport }}</a>
      </div>

      <!-- Upsell modal -->
      <div class="small-modal upgrade" *showForPlan="['Gratis', 'Basis', 'Plus']">
        <ng-container *showForPlan="['Gratis', 'Basis']">
          <p>{{ 'UPSELL.SUPPORT.PLUS.TOP_HEADING' | translate }}</p>
          <h2>{{ 'MAIN.PLANS.PLUS' | translate }}</h2>
          <p>{{ 'UPSELL.SUPPORT.PLUS.PRICE' | translate : { price: upsellPrices.plus } }}</p>
        </ng-container>
        <ng-container *showForPlan="['Plus']">
          <p>{{ 'UPSELL.SUPPORT.COMPLETE.TOP_HEADING' | translate }}</p>
          <h2>{{ 'MAIN.PLANS.COMPLEET' | translate }}</h2>
          <p>{{ 'UPSELL.SUPPORT.COMPLETE.PRICE' | translate : { price: upsellPrices.complete } }}</p>
        </ng-container>
        <div>
          <ul>
            <ng-template ngFor [ngForOf]="[0, 1, 2]" let-i="index">
              <li>
                <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.27 1.45C4.9 1.4 5.52 1.15 6 .73a3.07 3.07 0 0 1 3.98 0c.49.42 1.1.67 1.74.72a3.07 3.07 0 0 1 2.81 2.82c.06.64.3 1.25.73 1.74a3.07 3.07 0 0 1 0 3.98c-.42.49-.67 1.1-.72 1.74a3.07 3.07 0 0 1-2.82 2.81c-.64.06-1.25.3-1.74.73a3.07 3.07 0 0 1-3.98 0c-.49-.42-1.1-.67-1.74-.73a3.07 3.07 0 0 1-2.82-2.8 3.07 3.07 0 0 0-.72-1.75A3.07 3.07 0 0 1 .73 6c.42-.49.67-1.1.72-1.74a3.07 3.07 0 0 1 2.82-2.82Zm7.44 5.26a1 1 0 0 0-1.42-1.42L7 8.6l-1.3-1.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0l4-4Z"
                    fill="inherit"
                  />
                </svg>
                <p *showForPlan="['Gratis', 'Basis']">{{ 'UPSELL.SUPPORT.PLUS.FEATURE_' + i | translate }}</p>
                <p *showForPlan="['Plus']">{{ 'UPSELL.SUPPORT.COMPLETE.FEATURE_' + i | translate }}</p>
              </li>
            </ng-template>
          </ul>
          <tlw-button purple medium (click)="closeModal(); confirmUpsell()" *showForPlan="['Gratis', 'Basis']">
            {{ 'UPSELL.UPGRADE_DIRECTLY_TO' | translate : { plan: 'MAIN.PLANS.PLUS' | translate } }}
          </tlw-button>
          <tlw-button purple medium (click)="closeModal(); confirmUpsell()" *showForPlan="['Plus']">
            {{ 'UPSELL.SUPPORT.COMPLETE.BUTTON_TEXT' | translate }}
          </tlw-button>
          <p bottom-text *showForPlan="['Gratis', 'Basis']">{{ 'UPSELL.SUPPORT.PLUS.BOTTOM_TEXT' | translate }}</p>
          <p bottom-text *showForPlan="['Plus']">{{ 'UPSELL.SUPPORT.COMPLETE.BOTTOM_TEXT' | translate : { plan: 'MAIN.PLANS.COMPLEET' | translate } }}</p>
        </div>
      </div>
    </div>
  </modal-content>
</fnc-modal>

<fnc-confirm-dialogue
  [header]="'SETTINGS.ADMINISTRATION_BILLING_SCREEN.SUBSCRIPTION_UPGRADE' | translate"
  [content]="
    (lockUserToThisPlanForMonths === 0
      ? 'SETTINGS.ADMINISTRATION_BILLING_SCREEN.UPGRADE_MESSAGE'
      : 'SETTINGS.ADMINISTRATION_BILLING_SCREEN.UPGRADE_MESSAGE_ANNUAL'
    ) | translate : { plan: planName === 'Basis' || planName === 'Gratis' ? ('MAIN.PLANS.PLUS' | translate) : ('MAIN.PLANS.COMPLEET' | translate) }
  "
  [cancelKey]="'BUTTONS.BACK' | translate"
  [okKey]="'SETTINGS.ADMINISTRATION_BILLING_SCREEN.UPGRADE' | translate"
  (okButton)="closeModal(); billing.goToPaywallOrUpgrade('Support Modal')"
></fnc-confirm-dialogue>

<!-- Tellow Time Modal -->
<fnc-modal size="xlarge" #tellowTime windowClasses="no-background max-50-vw">
  <modal-content *ngIf="!(loading$ | async)">
    <div class="tellow-time-modal">
      <div class="tellow-time-container header-radius">
        <h2 [innerHTML]="'MODALS.TELLOW_TIME.HEADER' | translate"></h2>
        <div class="main">
          <div class="main-text">
            <p>{{ 'MODALS.TELLOW_TIME.TEXT_THREE' | translate }}</p>
            <p>{{ 'MODALS.TELLOW_TIME.TEXT_FOUR' | translate }}</p>
            <p>{{ 'MODALS.TELLOW_TIME.TEXT_FIVE' | translate }}</p>
          </div>

          <div class="qrcode">
            <img src="../../../../assets/images/modals/TellowTimeQRCode.png" alt="Tellow Time QR Code" />
            <a href="https://app.adjust.com/ws9c1yy" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="119.66407" height="40">
                <path
                  d="M110.13477 0H9.53468c-.3667 0-.729 0-1.09473.002-.30615.002-.60986.00781-.91895.0127a13.21476 13.21476 0 0 0-2.0039.17671 6.66509 6.66509 0 0 0-1.90088.627 6.43779 6.43779 0 0 0-1.61865 1.17866A6.25844 6.25844 0 0 0 .81935 3.61816a6.60119 6.60119 0 0 0-.625 1.90332 12.993 12.993 0 0 0-.1792 2.002C.00587 7.83008.00489 8.1377 0 8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232 12.99232 0 0 0 .1792 2.0019 6.58756 6.58756 0 0 0 .625 1.9043 6.20778 6.20778 0 0 0 1.17822 1.6143 6.27445 6.27445 0 0 0 1.61865 1.1787 6.70082 6.70082 0 0 0 1.90088.6308 13.45514 13.45514 0 0 0 2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567 40 9.168 40 9.53468 40h100.60009c.3594 0 .7246 0 1.084-.002.3047 0 .6172-.0039.9219-.0107a13.279 13.279 0 0 0 2-.1768 6.80432 6.80432 0 0 0 1.9082-.6308 6.27742 6.27742 0 0 0 1.6172-1.1787 6.39482 6.39482 0 0 0 1.1816-1.6143 6.60413 6.60413 0 0 0 .6191-1.9043 13.50643 13.50643 0 0 0 .1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621 0-.72949-.0078-1.09179 0-.30664 0-.61426-.0039-.9209a13.5071 13.5071 0 0 0-.1856-2.002 6.6177 6.6177 0 0 0-.6191-1.90332 6.46619 6.46619 0 0 0-2.7988-2.7998 6.76754 6.76754 0 0 0-1.9082-.627 13.04394 13.04394 0 0 0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002z"
                  fill="#a6a6a6"
                />
                <path
                  d="M8.44483 39.125c-.30468 0-.602-.0039-.90429-.0107a12.68714 12.68714 0 0 1-1.86914-.1631 5.88381 5.88381 0 0 1-1.65674-.5479 5.40573 5.40573 0 0 1-1.397-1.0166 5.32082 5.32082 0 0 1-1.02051-1.3965 5.72186 5.72186 0 0 1-.543-1.6572 12.41351 12.41351 0 0 1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434s.00884-.69141.01469-.89454a12.37039 12.37039 0 0 1 .16553-1.87207 5.7555 5.7555 0 0 1 .54346-1.6621 5.37349 5.37349 0 0 1 1.01514-1.39795 5.56543 5.56543 0 0 1 1.40234-1.02247 5.82309 5.82309 0 0 1 1.65332-.54394A12.58589 12.58589 0 0 1 7.543.88721L8.44532.875h102.76855l.9131.0127a12.38493 12.38493 0 0 1 1.8584.16259 5.93833 5.93833 0 0 1 1.6709.54785 5.59374 5.59374 0 0 1 2.415 2.41993 5.76267 5.76267 0 0 1 .5352 1.64892 12.995 12.995 0 0 1 .1738 1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079 1.09179V30.4648c0 .3633 0 .7178-.0079 1.0752 0 .3252 0 .6231-.0039.9297a12.73126 12.73126 0 0 1-.1709 1.8535 5.739 5.739 0 0 1-.54 1.67 5.48029 5.48029 0 0 1-1.0156 1.3857 5.4129 5.4129 0 0 1-1.3994 1.0225 5.86168 5.86168 0 0 1-1.668.5498 12.54218 12.54218 0 0 1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002z"
                />
                <g data-name="&lt;Group&gt;" fill="#fff">
                  <g data-name="&lt;Group&gt;">
                    <path
                      data-name="&lt;Path&gt;"
                      d="M24.76888 20.30068a4.94881 4.94881 0 0 1 2.35656-4.15206 5.06566 5.06566 0 0 0-3.99116-2.15768c-1.67924-.17626-3.30719 1.00483-4.1629 1.00483-.87227 0-2.18977-.98733-3.6085-.95814a5.31529 5.31529 0 0 0-4.47292 2.72787c-1.934 3.34842-.49141 8.26947 1.3612 10.97608.9269 1.32535 2.01018 2.8058 3.42763 2.7533 1.38706-.05753 1.9051-.88448 3.5794-.88448 1.65876 0 2.14479.88448 3.591.8511 1.48838-.02416 2.42613-1.33124 3.32051-2.66914a10.962 10.962 0 0 0 1.51842-3.09251 4.78205 4.78205 0 0 1-2.91924-4.39917zm-2.73163-8.08979a4.87248 4.87248 0 0 0 1.11452-3.49062 4.95746 4.95746 0 0 0-3.20758 1.65961 4.63634 4.63634 0 0 0-1.14371 3.36139 4.09905 4.09905 0 0 0 3.23677-1.53038z"
                    />
                  </g>
                  <path
                    d="M42.30227 27.13965h-4.7334l-1.13672 3.35645h-2.00488l4.4834-12.418h2.083l4.4834 12.418H43.438zm-4.24317-1.54883h3.752l-1.84961-5.44727h-.05176zm17.10059.37891c0 2.81348-1.50586 4.62109-3.77832 4.62109a3.0693 3.0693 0 0 1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238h1.79886v1.50586h.03418a3.21162 3.21162 0 0 1 2.88281-1.60059c2.29781.00001 3.8125 1.81641 3.8125 4.62208zm-1.91016 0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992 0-2.375 1.23047-2.375 3.03809 0 1.82422.95508 3.0459 2.375 3.0459 1.44532 0 2.39258-1.19629 2.39258-3.0459zm11.875 0c0 2.81348-1.50586 4.62109-3.77832 4.62109a3.0693 3.0693 0 0 1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418a3.21162 3.21162 0 0 1 2.88282-1.60058c2.29788 0 3.81253 1.8164 3.81253 4.62207zm-1.91016 0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992 0-2.375 1.23047-2.375 3.03809 0 1.82422.95508 3.0459 2.375 3.0459 1.44532 0 2.39259-1.19629 2.39259-3.0459zm8.4961 1.0664c.1377 1.23145 1.334 2.04 2.96875 2.04 1.56641 0 2.69336-.80859 2.69336-1.91895 0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766 0-2.14258 1.86719-3.61426 4.51855-3.61426 2.624 0 4.42285 1.47168 4.4834 3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148 1.8584c0 .87793.6543 1.39453 2.25488 1.79l1.36816.33594c2.54785.60254 3.60645 1.626 3.60645 3.44238 0 2.32324-1.85059 3.77832-4.79395 3.77832-2.75391 0-4.61328-1.4209-4.7334-3.667zm11.63574-7.73633v2.14258h1.72168v1.47168h-1.72168v4.99121c0 .77539.34473 1.13672 1.10156 1.13672a5.80752 5.80752 0 0 0 .61133-.043v1.46289a5.10351 5.10351 0 0 1-1.03223.08594c-1.833 0-2.54785-.68848-2.54785-2.44434v-5.18942h-1.3164v-1.47168H81.479V19.2998zm2.71879 6.66993c0-2.84863 1.67773-4.63867 4.29395-4.63867 2.625 0 4.29492 1.79 4.29492 4.63867 0 2.85645-1.66113 4.63867-4.29492 4.63867-2.63286 0-4.29395-1.78223-4.29395-4.63867zm6.69531 0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039 1.16211-2.40039 3.10742c0 1.96191.89453 3.10645 2.40039 3.10645s2.40133-1.14454 2.40133-3.10645zm3.42575-4.52735h1.77246v1.541h.043a2.1594 2.1594 0 0 1 2.17773-1.63574 2.86616 2.86616 0 0 1 .63672.06934v1.73828a2.59794 2.59794 0 0 0-.835-.1123 1.87264 1.87264 0 0 0-1.93652 2.083v5.37012h-1.8584zm13.19824 6.39453c-.25 1.64355-1.85059 2.77148-3.89844 2.77148-2.63379 0-4.26855-1.76465-4.26855-4.5957 0-2.83984 1.64355-4.68164 4.19043-4.68164 2.50488 0 4.08008 1.7207 4.08008 4.46582v.63672h-6.39453v.1123a2.358 2.358 0 0 0 2.43555 2.56445 2.04834 2.04834 0 0 0 2.09082-1.27344zm-6.28223-2.70215h4.52637a2.1773 2.1773 0 0 0-2.2207-2.29785 2.292 2.292 0 0 0-2.30567 2.29786z"
                  />
                </g>
                <path
                  d="M37.82619 8.731a2.63964 2.63964 0 0 1 2.80762 2.96484c0 1.90625-1.03027 3.002-2.80762 3.002h-2.15527V8.731zm-1.22852 5.123h1.125a1.87588 1.87588 0 0 0 1.96777-2.146 1.881 1.881 0 0 0-1.96777-2.13379h-1.125zm5.08301-1.40966a2.13323 2.13323 0 1 1 4.24707 0 2.13358 2.13358 0 1 1-4.24707 0zm3.333 0c0-.97607-.43848-1.54687-1.208-1.54687-.77246 0-1.207.5708-1.207 1.54688 0 .98389.43457 1.55029 1.207 1.55029.76954-.00001 1.20801-.57032 1.20801-1.5503zm6.55958 2.25341h-.92187l-.93066-3.31641h-.07031l-.92676 3.31641h-.91309l-1.24121-4.50293h.90137l.80664 3.436h.06641l.92578-3.436h.85254l.92578 3.436h.07031l.80273-3.436h.88867zm2.28028-4.50293h.85546v.71533h.06641a1.348 1.348 0 0 1 1.34375-.80225 1.46456 1.46456 0 0 1 1.55859 1.6748v2.915h-.88867v-2.69184c0-.72363-.31445-1.0835-.97168-1.0835a1.03294 1.03294 0 0 0-1.0752 1.14111v2.63428h-.88867zM59.09377 8.437h.88867v6.26074h-.88867zm2.12402 4.00734a2.13346 2.13346 0 1 1 4.24756 0 2.1338 2.1338 0 1 1-4.24756 0zm3.333 0c0-.97607-.43848-1.54687-1.208-1.54687-.77246 0-1.207.5708-1.207 1.54688 0 .98389.43457 1.55029 1.207 1.55029.76953-.00001 1.20801-.57032 1.20801-1.5503zm1.85011.97998c0-.81055.60352-1.27783 1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609 0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953 1.83984-1.26953 1.12891 0 1.76563.562 1.76563 1.51318v3.07666h-.85547v-.63281h-.07031a1.515 1.515 0 0 1-1.35254.707 1.36026 1.36026 0 0 1-1.50098-1.34763zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941 0 .40527.35156.64111.835.64111a1.0615 1.0615 0 0 0 1.16598-.98437zm2.05273-.59521c0-1.42285.73145-2.32422 1.86914-2.32422a1.484 1.484 0 0 1 1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284 1.56284 0 0 1-1.41406.78564c-1.14551.00005-1.86915-.90134-1.86915-2.32761zm.918 0c0 .95508.4502 1.52979 1.20313 1.52979.749 0 1.21191-.583 1.21191-1.52588 0-.93848-.46777-1.52979-1.21191-1.52979-.74808 0-1.20316.57861-1.20316 1.52588zm7.07126-3.58106a.57572.57572 0 1 1 .5752.5415.54735.54735 0 0 1-.5752-.5415zm.13184 1.33154h.88574v4.50293h-.88574zm2.31933 0h.85547v.71533h.06641a1.348 1.348 0 0 1 1.34375-.80225 1.46456 1.46456 0 0 1 1.55859 1.6748v2.915h-.88867v-2.69184c0-.72363-.31445-1.0835-.97168-1.0835a1.03294 1.03294 0 0 0-1.0752 1.14111v2.63428h-.88867zm7.41895 2.24952c0-1.42285.73145-2.32422 1.86914-2.32422a1.484 1.484 0 0 1 1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284 1.56284 0 0 1-1.41406.78564c-1.14552.00005-1.86915-.90134-1.86915-2.32761zm.918 0c0 .95508.4502 1.52979 1.20313 1.52979.749 0 1.21191-.583 1.21191-1.52588 0-.93848-.46777-1.52979-1.21191-1.52979-.74808 0-1.20316.57861-1.20316 1.52588zm8.5527 1.03759a1.828 1.828 0 0 1-1.95117 1.30273 2.04531 2.04531 0 0 1-2.08007-2.32421 2.07685 2.07685 0 0 1 2.07617-2.35254c1.25293 0 2.00879.856 2.00879 2.27v.31009h-3.17969v.0498a1.1902 1.1902 0 0 0 1.19922 1.29 1.07934 1.07934 0 0 0 1.07129-.5459zm-3.126-1.45117h2.27441a1.08647 1.08647 0 0 0-1.1084-1.1665 1.15162 1.15162 0 0 0-1.16598 1.1665z"
                  fill="#fff"
                  data-name="&lt;Group&gt;"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </modal-content>
</fnc-modal>

<!-- Upsells -->
<tlw-full-screen-upsell-modal
  #expenseModal
  [data]="{
    locationForTracking: 'Expense Modal - ' + incomeTaxModalLocation,
    tierToUpgradeTo: 1
  }"
></tlw-full-screen-upsell-modal>

<tlw-full-screen-upsell-modal
  #quoteModal
  [data]="{
    locationForTracking: 'Quotes Modal',
    tierToUpgradeTo: 2
  }"
></tlw-full-screen-upsell-modal>

<tlw-full-screen-upsell-modal
  #incomeTaxModal
  [data]="{
    locationForTracking: 'Compleet Modal - ' + incomeTaxModalLocation,
    tierToUpgradeTo: 3
  }"
></tlw-full-screen-upsell-modal>

<!-- IB Modal -->
<fnc-modal size="medium" #ibModal>
  <modal-content>
    <div class="info-modal">
      <span class="info-modal__info">
        <h1>Tellow Compleet</h1>

        <p class="subheader">Tellow's nieuwe pakket; beschikbaar voor 2021.</p>
        <p>
          De volledige boekhouder die alles voor je doet, persoonlijk en zakelijk! Met Tellow Compleet geef je je hele administratie en aangiftes uit handen.
          Dus ook je persoonlijke inkomstenbelasting aangifte 2021 (IB) én die van je fiscale partner.
        </p>
        <p>
          <span>Meer weten?</span> <br />
          <a href="https://www.tellow.nl/lp/tellowcompleet/" rel="noopener noreferrer" target="blank">Lees hier meer.</a>
        </p>
      </span>

      <hr />

      <a class="info-modal__row" href="https://tellow.typeform.com/to/CEJJCOwH" rel="noopener noreferrer" target="blank">
        Schrijf je (vrijblijvend) in op de wachtlijst →
      </a>
    </div>
  </modal-content>
</fnc-modal>

<!-- Ageras Synergy -->
<fnc-modal noOverflow size="large" [withDefaultPadding]="0" #agerasModal [modalClasses]="'ageras-modal'">
  <modal-content>
    <div class="ageras-modal__header">
      <svg viewBox="0 0 108 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M78.83 8.52H84.11c.21 0 .3.07.35.28l1.7 5.93 1.05 3.69c.02.09.01.2.14.25l.84-2.47 2.46-7.3c.14-.45.04-.38.52-.38h4.86c.4 0 .41 0 .53.37l3.24 9.74.03.09c.1-.06.11-.17.14-.26l2.69-9.47.08-.27c.02-.16.11-.2.25-.2h4.99c.06.14-.02.26-.05.36l-5.21 16.68c-.1.33-.11.33-.44.33h-4.65c-.36 0-.32.08-.45-.32l-3.53-10.36a.86.86 0 0 0-.2-.44l-1.17 3.5-2.45 7.3c-.1.33-.1.33-.44.33h-4.72c-.36 0-.36 0-.46-.31l-5.3-16.73-.08-.34ZM10.46 1.13H20.7c.19-.02.26.05.25.25v4.68c0 .33 0 .33-.34.33H13.7c-.53 0-.45-.04-.45.46V25.4c0 .56.07.48-.5.48H8.11c-.5 0-.45.07-.45-.46V6.91c0-.6.1-.51-.5-.51H.15C.04 6.4 0 6.34 0 6.25V1.52c0-.45-.05-.4.43-.4h10.03ZM45.72 13.28v12.15c0 .5.05.45-.47.45h-4.53c-.37 0-.37 0-.37-.38V1.04c0-.5-.06-.44.46-.44h4.49c.46 0 .42-.05.42.4v12.28ZM50.44 13.24V1.04c0-.52-.06-.44.46-.44h4.57c.3 0 .32-.03.32.3V25.57c0 .3 0 .3-.32.3h-4.69c-.34 0-.34 0-.34-.35V13.24Z"
          fill="#002E33"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M72.1 8.4a9.47 9.47 0 0 0-3.62-.73c-2.5-.02-4.9.93-6.69 2.65a9.32 9.32 0 0 0-.21 13.2 9.46 9.46 0 0 0 6.6 2.86 9.4 9.4 0 0 0 9.01-12.89 9.32 9.32 0 0 0-5.1-5.1Zm.6 8.13a4.26 4.26 0 0 0-6-3.4 4.28 4.28 0 0 0-1.72 6.44c.46.61 1.08 1.1 1.8 1.38.95.43 2.03.47 3.02.11a2.6 2.6 0 0 1 1.83-.03c.14.05.28.09.43.12.33.09.42 0 .33-.34l-.01-.03-.12-.43c-.16-.5-.13-1.03.09-1.5.33-.73.45-1.53.35-2.32ZM35.14 23.6a7.26 7.26 0 0 0 1.44-2.7 2.52 2.52 0 0 1-.31-.12l-3.8-1.07c-.36-.1-.36-.1-.5.22a3.13 3.13 0 0 1-2.1 1.78c-.31.1-.64.14-.96.15a4.2 4.2 0 0 1-3.51-1.37 3.13 3.13 0 0 1-.8-1.93c.15-.05.3-.06.46-.04h11.47c.2.03.28-.04.3-.25a12.4 12.4 0 0 0-.25-4.13 7.45 7.45 0 0 0-4.44-5.4 9.4 9.4 0 0 0-4.9-.7A8.43 8.43 0 0 0 20 13.63a9.74 9.74 0 0 0-.48 5.36 8.54 8.54 0 0 0 3.4 5.64 9.76 9.76 0 0 0 9.8.85 7.32 7.32 0 0 0 2.41-1.88Zm-3.83-8.48a.7.7 0 0 0 .37-.03.9.9 0 0 0 .01-.12c0-.07 0-.13-.02-.2a2.89 2.89 0 0 0-1.87-2.3 4.28 4.28 0 0 0-2.24-.23 3.26 3.26 0 0 0-2.84 2.71c0 .12.03.17.15.17h6.44Z"
          fill="#002E33"
        />
      </svg>
      <tlw-icon icon="close" library="heroicons" variant="mini"></tlw-icon>
      <svg viewBox="0 0 955 152" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M393.168 21.7607V20.973C385.487 7.48331 371.21 0 355.751 0C324.046 0 303.86 22.7453 303.86 53.2693C303.86 82.9072 323.258 106.932 354.471 106.932C373.081 106.932 387.555 98.0707 393.069 83.9903V104.963H416.011V2.16622H396.614L393.168 21.7607ZM360.084 86.4519C340.686 86.4519 326.803 72.7653 326.803 53.3678C326.803 34.1672 340.686 20.4806 360.084 20.4806C379.284 20.4806 393.168 34.758 393.168 53.3678C393.168 72.1745 379.284 86.4519 360.084 86.4519Z"
          fill="#002E33"
        />
        <path
          d="M638.538 77.5901C633.319 83.5964 625.147 88.0273 614.02 88.0273C596.986 88.0273 583.693 76.9008 582.314 60.9496H664.828C665.812 21.7607 643.461 0 612.149 0C581.527 0 559.471 23.1392 559.471 53.6632C559.471 85.7626 582.413 106.932 613.725 106.932C635.091 106.932 652.421 95.4121 660.003 80.0517L638.538 77.5901ZM612.149 18.4129C628.987 18.4129 640.802 29.3424 641.393 43.7183H582.216C583.496 29.047 596.001 18.4129 612.149 18.4129Z"
          fill="#002E33"
        />
        <path
          d="M701.461 17.6249L698.31 2.16593H679.7V104.864H702.446L702.249 41.7487C703.036 25.8959 714.754 19.0034 734.545 21.5634L734.742 1.96899C717.117 -0.394155 707.073 6.69529 701.461 17.6249Z"
          fill="#002E33"
        />
        <path
          d="M828.38 21.7607V20.973C820.699 7.48331 806.422 0 790.963 0C759.258 0 739.072 22.7453 739.072 53.2693C739.072 82.9072 758.47 106.932 789.683 106.932C808.293 106.932 822.767 98.0707 828.281 83.9903V104.963H851.223V2.16622H831.826L828.38 21.7607ZM795.394 86.4519C775.996 86.4519 762.113 72.7653 762.113 53.3678C762.113 34.1672 775.996 20.4806 795.394 20.4806C814.595 20.4806 828.478 34.758 828.478 53.3678C828.38 72.1745 814.595 86.4519 795.394 86.4519Z"
          fill="#002E33"
        />
        <path
          d="M892.478 28.8498C892.478 21.7603 899.961 17.3294 909.512 17.3294C920.836 17.3294 927.925 23.4342 929.107 32.1976L950.671 31.6068C949.883 13.7847 933.243 0.0981445 909.709 0.0981445C887.949 0.0981445 870.521 11.6185 870.521 30.3268C870.521 67.7433 931.47 56.026 931.47 76.6051C931.47 84.2853 923.79 88.9132 912.466 88.9132C899.174 88.9132 889.327 82.8084 888.146 72.0757L865.991 72.8635C867.173 96.3965 887.949 106.735 911.679 106.735C936.59 106.735 954.215 95.6087 954.215 75.6205C954.215 36.8254 892.478 49.035 892.478 28.8498Z"
          fill="#002E33"
        />
        <path
          d="M520.876 104.865C533.874 104.865 544.016 94.329 544.016 81.3317V2.16622H525.209L521.27 21.9576V20.973C513.59 7.48331 499.313 0 483.854 0C452.148 0 431.963 22.7453 431.963 53.2693C431.963 82.9072 451.36 106.932 482.574 106.932C501.183 106.932 515.658 98.0707 521.172 83.9903H521.369V96.6922C521.369 115.794 507.091 130.367 487.989 130.367C475.681 130.367 465.441 124.361 459.631 115.105H434.917C442.203 136.767 462.388 151.143 487.891 151.143C517.233 151.143 539.486 132.139 543.228 104.963H537.714H520.876V104.865ZM488.186 86.4519C468.789 86.4519 454.905 72.7653 454.905 53.3678C454.905 34.1672 468.789 20.4806 488.186 20.4806C507.387 20.4806 521.27 34.758 521.27 53.3678C521.27 72.1745 507.387 86.4519 488.186 86.4519Z"
          fill="#002E33"
        />
        <path
          d="M148.78 2.1665H100.04C100.04 22.8441 104.274 42.4385 111.856 60.359H81.4302C63.3127 85.7629 33.5764 102.305 0 102.305V151.045C52.0877 151.045 97.8738 124.263 124.558 83.7936C151.143 124.263 196.929 151.045 249.017 151.045V102.305C193.68 102.305 148.78 57.5036 148.78 2.1665Z"
          fill="#002E33"
        />
      </svg>
    </div>

    <div class="ageras-modal__content">
      <div class="ageras-modal__content__heading">
        <h2>
          {{ 'MODALS.AGERAS_MODAL.TITLE_PART_ONE' | translate }} <span>{{ 'MODALS.AGERAS_MODAL.TITLE_PART_TWO' | translate }}</span>
        </h2>
        <p>
          {{ 'MODALS.AGERAS_MODAL.DESCRIPTION' | translate }}
        </p>
      </div>

      <div class="ageras-modal__content__steps">
        <p class="ageras-modal__content__steps--title">{{ 'MODALS.AGERAS_MODAL.STEPS.TITLE' | translate }}</p>
        <ul class="ageras-modal__content__steps--list">
          <li>{{ 'MODALS.AGERAS_MODAL.STEPS.ONE' | translate }}</li>
          <li>{{ 'MODALS.AGERAS_MODAL.STEPS.TWO' | translate }}</li>
          <li>{{ 'MODALS.AGERAS_MODAL.STEPS.THREE' | translate }}</li>
        </ul>
      </div>

      <div class="ageras-modal__content__cta">
        <tlw-button purple medium (fncClick)="redirectToAgerasTypeform()">{{ 'MODALS.AGERAS_MODAL.CTA_BUTTON' | translate }}</tlw-button>
        <!-- <a href="https://nl.ageras.com/hoe-werkt-het" target="_blank">{{ 'MODALS.AGERAS_MODAL.CTA_LINK' | translate }}<span>&nbsp;></span></a> -->
      </div>

      <!-- <div class="ageras-modal__content__disclaimer">
        <p>
          {{ 'MODALS.AGERAS_MODAL.DISCLAIMER' | translate }}
        </p>
      </div> -->
    </div>
  </modal-content>
</fnc-modal>

<!-- Bank Fees Consent Modal -->
<fnc-modal
  size="medium"
  modalClasses="bankFeesConsent"
  [useDarkOverlay]="true"
  [useBlur]="true"
  [dontCloseOnDocumentClick]="true"
  [dontCloseOnEscape]="true"
  #bankFeesConsentModal
>
  <modal-content bankFeesConsent>
    <h2>{{ 'MODALS.BANKING_FEE_CONSENT.TITLE' | translate }}</h2>

    <p>
      {{ 'MODALS.BANKING_FEE_CONSENT.PARAGRAPH_ONE' | translate }}
    </p>
    <p>
      {{ 'MODALS.BANKING_FEE_CONSENT.PARAGRAPH_TWO' | translate : { today: bankingBillingDate | fncDate : { format: 'DD MMMM yyyy' } } }}
    </p>
    <p>
      {{ 'MODALS.BANKING_FEE_CONSENT.PARAGRAPH_THREE' | translate }}
    </p>
    <p>
      {{ 'MODALS.BANKING_FEE_CONSENT.PARAGRAPH_FOUR' | translate }}
    </p>
  </modal-content>
  <modal-buttons bankFeesConsent>
    <fnc-button light-red big (click)="closeSwanAccount()" [disabled]="disableBankingFeeModalButtons$ | async">
      {{ 'MODALS.BANKING_FEE_CONSENT.CLOSE_ACCOUNT_BUTTON' | translate }}
    </fnc-button>
    <fnc-button purple big (click)="acceptBankingFeesConsent()" [disabled]="disableBankingFeeModalButtons$ | async">
      {{ 'MODALS.BANKING_FEE_CONSENT.ACCEPT_FEES_BUTTON' | translate }}
    </fnc-button>
  </modal-buttons>
</fnc-modal>

<!-- Tax Buckets Onboarding Modal -->
<fnc-modal
  size="xlarge"
  #taxBucketsOnboardingModal
  windowClasses="no-background max-50-vw tax-buckets-onboarding-modal"
  [dontCloseOnDocumentClick]="true"
  [dontCloseOnEscape]="true"
>
  <modal-content>
    <div class="container">
      <div class="header">
        <span class="dismiss-button" (click)="dismissTaxBucketsOnboadingModal()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
            <path
              fill="#5F6368"
              fill-rule="evenodd"
              d="M1.295.201A.747.747 0 0 0 .037.737a.751.751 0 0 0 .201.524l5.705 5.72-5.705 5.72a.75.75 0 0 0 .814 1.234.748.748 0 0 0 .243-.174L7 8.041l5.705 5.72A.747.747 0 0 0 14 13.237a.752.752 0 0 0-.238-.536l-5.705-5.72 5.705-5.72a.75.75 0 0 0-.534-1.26.747.747 0 0 0-.523.2L7 5.921 1.295.201Z"
              clip-rule="evenodd"
            />
          </svg>
        </span>
      </div>
      <div class="content">
        <div class="animation">
          <ng-lottie height="auto" [options]="taxBucketsLottieAnimationOptions"></ng-lottie>
        </div>
        <div class="info">
          <h1>{{ 'TAX_BUCKETS.ONBOARDING.TITLE' | translate }}</h1>
          <p>{{ 'TAX_BUCKETS.ONBOARDING.DESCRIPTION' | translate }}</p>
          <tlw-button purple size="large" [disabled]="disableTaxBucketsOnboardingModalButtons$ | async" (fncClick)="startTaxBucketsOrUpgrade()">
            <svg *ngIf="!(billing.canUseTaxBucket$ | async)" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.49969 7V5C2.49969 3.67392 3.02648 2.40215 3.96416 1.46447C4.90184 0.526784 6.17361 0 7.49969 0C8.82578 0 10.0975 0.526784 11.0352 1.46447C11.9729 2.40215 12.4997 3.67392 12.4997 5V7C13.0301 7 13.5388 7.21071 13.9139 7.58579C14.289 7.96086 14.4997 8.46957 14.4997 9V14C14.4997 14.5304 14.289 15.0391 13.9139 15.4142C13.5388 15.7893 13.0301 16 12.4997 16H2.49969C1.96926 16 1.46055 15.7893 1.08548 15.4142C0.710408 15.0391 0.499695 14.5304 0.499695 14V9C0.499695 8.46957 0.710408 7.96086 1.08548 7.58579C1.46055 7.21071 1.96926 7 2.49969 7ZM10.4997 5V7H4.49969V5C4.49969 4.20435 4.81577 3.44129 5.37837 2.87868C5.94098 2.31607 6.70404 2 7.49969 2C8.29534 2 9.05841 2.31607 9.62101 2.87868C10.1836 3.44129 10.4997 4.20435 10.4997 5Z"
                fill="white"
              />
            </svg>
            {{ ((billing.canUseTaxBucket$ | async) ? 'TAX_BUCKETS.ONBOARDING.ENABLE' : 'TAX_BUCKETS.ONBOARDING.UPGRADE_AND_ENABLE') | translate }} ->
          </tlw-button>
        </div>
      </div>
    </div>
  </modal-content>
</fnc-modal>

<!-- No Balance Modal -->
<fnc-confirm-dialogue
  okKey="BANKING.TOPUP.ADD_MONEY"
  (okButton)="goToTopupScreen()"
  #noBalanceModal
  headerText="BANKING.TRANSFER.INSUFFICIENT_BALANCE_HEADER"
  [content]="'BANKING.TRANSFER.INSUFFICIENT_BALANCE' | translate"
></fnc-confirm-dialogue>

<!-- Passkeys Modal -->
<fnc-modal #passkeysModal size="medium" windowClasses="passkeys-modal" [dontCloseOnDocumentClick]="true" [dontCloseOnEscape]="true">
  <modal-content>
    <div class="passkeys-modal__header">
      <h2>{{ 'MODALS.PASSKEYS_MODAL.TITLE' | translate }} 👋</h2>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" (click)="dismissPasskeyModal()">
        <path
          fill="#5F6368"
          fill-rule="evenodd"
          d="M1.295.201A.747.747 0 0 0 .037.737a.751.751 0 0 0 .201.524l5.705 5.72-5.705 5.72a.75.75 0 0 0 .814 1.234.748.748 0 0 0 .243-.174L7 8.041l5.705 5.72A.747.747 0 0 0 14 13.237a.752.752 0 0 0-.238-.536l-5.705-5.72 5.705-5.72a.75.75 0 0 0-.534-1.26.747.747 0 0 0-.523.2L7 5.921 1.295.201Z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
    <div class="passkeys-modal__content">
      <div class="passkeys-modal__content--description">
        <p class="bold large">{{ 'MODALS.PASSKEYS_MODAL.SUBTITE' | translate }}</p>
        <p>{{ 'MODALS.PASSKEYS_MODAL.DESCRIPTION' | translate }}</p>
      </div>
      <div class="passkeys-modal__content--points">
        <div class="passkeys-modal__content--points__point">
          <span>
            <tlw-icon icon="shield" library="custom" color="purple" height="20"></tlw-icon>
          </span>
          <div>
            <p class="bold large">{{ 'MODALS.PASSKEYS_MODAL.POINTS.SECURITY_TITLE' | translate }}</p>
            <p>{{ 'MODALS.PASSKEYS_MODAL.POINTS.SECURITY_DESCRIPTION' | translate }}</p>
          </div>
        </div>
        <div class="passkeys-modal__content--points__point">
          <span>
            <tlw-icon icon="lock" library="custom" color="purple" height="20"></tlw-icon>
          </span>
          <div>
            <p class="bold large">{{ 'MODALS.PASSKEYS_MODAL.POINTS.CONVENIENCE_TITLE' | translate }}</p>
            <p>{{ 'MODALS.PASSKEYS_MODAL.POINTS.CONVENIENCE_DESCRIPTION' | translate }}</p>
          </div>
        </div>
        <div class="passkeys-modal__content--points__point">
          <span>
            <tlw-icon icon="lightning" library="custom" color="purple" height="20"></tlw-icon>
          </span>
          <div>
            <p class="bold large">{{ 'MODALS.PASSKEYS_MODAL.POINTS.SEAMLESS_TITLE' | translate }}</p>
            <p>{{ 'MODALS.PASSKEYS_MODAL.POINTS.SEAMLESS_DESCRIPTION' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="passkeys-modal__content--need-help">
        <p class="bold gray">{{ 'SETTINGS.PASSKEYS.FIRST_PASSKEY_MODAL.NEED_HELP' | translate }}</p>
        <p class="gray small">
          {{ 'SETTINGS.PASSKEYS.FIRST_PASSKEY_MODAL.HELP_CENTER.1' | translate }}
          <a target="_blank" [href]="helpCenterUrl" class="gray small">{{ 'SETTINGS.PASSKEYS.FIRST_PASSKEY_MODAL.HELP_CENTER.2' | translate }}</a>
          {{ 'SETTINGS.PASSKEYS.FIRST_PASSKEY_MODAL.HELP_CENTER.3' | translate }}
        </p>
      </div>
      <fnc-button purple medium (fncClick)="goToPasskeys()">
        {{ 'MODALS.PASSKEYS_MODAL.CTA' | translate }}
      </fnc-button>
    </div>
  </modal-content>
</fnc-modal>
